import React from 'react';
import mapaBrasil from '../assets/images/brasil.png';
import tecnologia from '../assets/images/tecnologia.png';
import pessoas from '../assets/images/pessoas.png';
import servicos from '../assets/images/servicos.png';

const WhyChoise = () => {
    return (
        <section className="why-choise py-5" id="porque-escolher">
            <div className="container pb-5">
                <div className="row py-5">
                    <div className="col-12 text-center">Porque escolher a <span>Saúde Móvel Brasil</span>?</div>
                </div>
                <div className="row pt-3 custom-shadow">
                    <div className="col-lg-3 col-12 text-center custom-border-right">
                        <div className='text-center'><img src={mapaBrasil} className="img img-fluid rounded-5 center-img" alt="Mapa do Brasil" />
                        </div>
                        <div className="title-card py-4">Cobertura Nacional:</div>
                        <div className="content-card pb-4">Estamos prontos para atuar em qualquer região do Brasil, levando cuidados de saúde de qualidade onde você precisar.</div>
                    </div>
                    <div className="col-lg-3 col-12 text-center custom-border-right">
                        <div><img src={tecnologia} className="img img-fluid rounded-5 center-img" alt="Tecnologia" />
                        </div>
                        <div className="title-card py-4">Tecnologia de Ponta:</div>
                        <div className="content-card pb-4">Nossas unidades móveis são equipadas com oque há de mais moderno em equipamentos de diagnóstico e atendimento médico.</div>
                    </div>
                    <div className="col-lg-3 col-12 text-center custom-border-right">
                        <div><img src={pessoas} className="img img-fluid rounded-5 center-img" alt="Pessoas" />
                        </div>
                        <div className="title-card py-4">Equipe Especializada:</div>
                        <div className="content-card pb-4">Contamos com profissionais altamente qualificados, comprometidos com o melhor atendimento e resultados.</div>
                    </div>
                    <div className="col-lg-3 col-12 text-center custom-border-right">
                        <div><img src={servicos} className="img img-fluid rounded-5 center-img" alt="Serviços" />
                        </div>
                        <div className="title-card py-4">Serviços Personalizados:</div>
                        <div className="content-card pb-4">Ajustamos nossos serviços e exames conforme as necessidades específicas de seu evento ou empresa, oferecendo uma solução sob medida para cada situação.</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyChoise;